import CompanyUserRegistrationReducer from './CompanyUserRegistrationReducer';

export default from './CompanyUserRegistrationContainer';
export const CompanyUserRegistrationReducers = {
  CompanyUserRegistrationReducer,
};
